import { render, staticRenderFns } from "./SubOrdersTable.vue?vue&type=template&id=f52e79ce"
import script from "./SubOrdersTable.vue?vue&type=script&lang=js"
export * from "./SubOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports